<template>
  <!-- 设计方区域 -->
  <div class="step4">
    <div class="content">
      <div
        v-if="!isChoose"
        class="form"
      >
        <!-- 若您的作品获奖，本页信息将标注于您的奖状/奖杯上。 -->
        <div style="font-size: 12px; color: #999999; margin-top: 18px;">
          {{ $t('user-productInfo-design/awardsTip') }}
        </div>
        <a-form
          class="ant-advanced-search-form formBox"
          :form="form"
        >
          <a-row :gutter="24">
            <a-col
              span="24"
              style="margin-bottom: 24px;"
            >
              <!-- <div style="color: #333333; margin: 18px 0 8px;">
                {{ $t('user-productInfo-design/tip') }}
              </div> -->
              <!-- 新增信息按钮 -->
              <a-button type="primary" @click="switchList('design_address')">{{ $t('view-components-components/addMessageP2') }}</a-button>
              <!-- <span style="color: #ed1c24;cursor: pointer;" ></span> -->
            </a-col>
            <a-col
              v-if="form.design_address.length"
              span="24"
            >
              <div class="list">
                <div
                  v-for="(item, index) in form.design_address"
                  :key="item.id"
                  class="item"
                >
                  <a-icon
                    type="delete"
                    class="del"
                    @click="del(index, 'design_address')"
                  />
                  <div v-for="(i, index2) in item.contact" :key="index2">
                    <a-row
                      :gutter="24"
                    >
                      <a-col span="4">
                        <b>{{ $route.path !== '/user/myProduct' ? $t('register/profile') : $t('user-productInfo-brand/profile') }}</b>
                      </a-col>
                      <a-col span="4">
                        {{ $t('user-account-address/name') }}
                      </a-col>
                      <a-col span="5">
                        <b>{{ $t('register/identificationNumber') }}</b>
                      </a-col>
                      <a-col span="4">
                        {{ $t('user-productInfo-brand/phone') }}
                      </a-col>
                      <a-col span="4">
                        {{ $t('register/otherName') }}
                      </a-col>
                    </a-row>
                    <a-row
                      :gutter="24"
                      style="margin-top: 7px;"
                    >
                      <a-col span="4" />
                      <a-col span="4">
                        <span>{{ i.name }} </span>
                        <!-- <span v-if="$i18n.locale === 'en'">{{ item.firstname }} {{ item.lastname }}</span>
                        <span v-if="$i18n.locale !== 'en'">{{ item.lastname }} {{ item.firstname }}</span> -->
                      </a-col>
                      <a-col span="5" style="word-break: break-all; white-space: normal;">
                        <!-- {{ $i18n.locale === 'en' ? i.company_ename : i.company_name }} -->
                        {{ i.sfzhm }}
                      </a-col>
                      <a-col span="4" style="word-break: break-all; white-space: normal;">
                        {{ i.phone }}
                      </a-col>
                      <a-col span="4" style="overflow: hidden;text-overflow: ellipsis">
                        {{ i.other_name }}
                      </a-col>
                      <!-- <a-col span="" style="margin-left: 20px; margin-top: -30px;">
                        <a-button
                          v-if="index2 == 0"
                          type="primary"
                          @click="editAddress(index)"
                        >
                          {{ $t('user-address/edit') }}
                        </a-button>
                      </a-col> -->
                    </a-row>
                  </div>
                </div>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 对作品的描述，有可能是已经完成的作品 -->
      <describe
        :describe="describe"
        flot="true"
      />
      <!-- 可以编辑的时候的设计方页面 -->
      <addressList
        v-if="isChoose"
        style="width: 94%;"
        :is-set="true"
        :type="type"
        :show-all="true"
        @setAddress="setAddress"
      />
      <div style="width: 383px;" />
    </div>
  </div>
</template>
<script>
import describe from './describe'
import addressList from '../../address'

export default {
  components: {
    describe,
    addressList
  },
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    describe: {
      type: Object,
      default: () => {}
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isChoose: false,
      type: ''
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale
    }
  },
  watch: {
    locale(e) {
      console.log(e) // 根据e对变量重新赋值
    },
    form: {
      handler(e) {
        console.log('e-sdghoishdgio', e)
        // 检查 design_addrss 或 design_address 是否为空
        const hasDesignAddress = (e.design_addrss && e.design_addrss.length > 0) || (e.design_address && e.design_address.length > 0)
        if (!hasDesignAddress) {
          this.switchList('design_address')
        } else {
          this.isChoose = false
          this.type = ''
        }
      },
      deep: true // 添加深度监听
    }
  },
  created() {
    console.log('this.form', this.form)
    // 检查 design_addrss 或 design_address 是否为空
    const hasDesignAddress = (this.form.design_addrss && this.form.design_addrss.length > 0) || (this.form.design_address && this.form.design_address.length > 0)
    if (!hasDesignAddress) this.switchList('design_address')
  },
  methods: {
    switchList(type) {
      if (this.readonly) return
      this.isChoose = true
      this.type = type
    },
    setAddress(address) {
      this.isChoose = false
      this.$emit('setStep4', address, this.type)
    },
    del(index, type) {
      if (this.readonly) return
      console.log('del', index, type)
      this.$emit('setStep4', index, type, true)
    }
  }
}
</script>
<style scoped>
  .content {
    display: flex;
  }

  .form {
    flex: 1;
    padding-bottom: 180px;
  }

  .formBox {
    /* margin-right: 54px; */
    padding-top: 10px;
  }

  .subTitle {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin-top: 6px;
  }

  .tip {
    font-size: 14px;
    color: #999999;
    margin-top: 4px;
    line-height: 14px;
  }

  .list {
    clear: both;
    font-size: 16px;
    margin-bottom: 50px;
  }

  .list_title {
    font-size: 18px;
    font-weight: bold;
    color: #ed1c24;
    margin: 6px 0 10px;
  }

  .list .item {
    background: #ffffff;
    padding: 28px 15px;
    position: relative;
  }

  .list .item .del {
    position: absolute;
    top: -24px;
    right: 8px;
    color: #ed1c24;
    font-size: 20px;
    cursor: pointer;
  }

  .list .item + .item {
    margin-top: 32px;
  }
</style>
